import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

export const selectCalendarEventType = (state:RootState) => state.calendarEventTypes.eventType;
export const selectCalendarEventTypes = (state:RootState) => state.calendarEventTypes.eventTypes;

export const selectCalendarEventTypesAsOptions = createSelector(
  [selectCalendarEventTypes],
  (eventTypes) => {
    if (!eventTypes) return [];
    return eventTypes.map(eventType => ({
      id: eventType.id,
      name: eventType.name,
    }));
  }
);

